import {
  IconButton,
  Typography,
  Toolbar,
  AppBar,
  //useTheme,
  Button,
  Stack,
} from "@mui/material";
import {
  //DarkMode,
  //LightMode,
  Menu,
  MenuOpen,
  PowerSettingsNew,
} from "@mui/icons-material";
import { useContext } from "react";
//import { AppContext } from "./App";
import { MainLayOutContect } from "./MainLayout";
import Swal from "sweetalert2";

export default function NavBar() {
  //const theme = useTheme();
  //const { handleMode } = useContext(AppContext);
  const { togleCollapse, setTogleCollapse } = useContext(MainLayOutContect);
  return (
    <AppBar position="sticky" enableColorOnDark>
      <Toolbar variant="dense">
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ mr: 2 }}
          onClick={() => setTogleCollapse(!togleCollapse)}
        >
          {togleCollapse ? <MenuOpen /> : <Menu />}
        </IconButton>
        <Stack direction={"row"} spacing={1} flexGrow={1} whiteSpace={'nowrap'} overflow={'hidden'}>
          <Typography alignSelf={'center'} variant="h6">GPS ThaiTracking :</Typography>
          <Typography alignSelf={'center'} variant="body1">Logistics Control Center Management (LCCM)</Typography>
        </Stack>       
        <Button
          sx={{ ml: 2, whiteSpace: "nowrap" }}
          variant="text"
          endIcon={<PowerSettingsNew />}
          color="inherit"
          onClick={() => {
            Swal.fire({
              title: "ต้องการออกจากระบบ?",
              icon: "question",
              showCancelButton: true,
              confirmButtonColor: "#1976D2",
            }).then((result) => {
              if (result.isConfirmed) {
                localStorage.removeItem("token");
                window.location.href = "/authen";
              }
            });
          }}
        >
          ออกจากระบบ
        </Button>
      </Toolbar>
    </AppBar>
  );
}
